import { useRef } from "react"
import { useTranslation } from "react-i18next"

import { Button } from "@/components/Button"
import { DefaultAdaptiveLogo } from "@/components/logos/AdaptiveLogo"
import { join } from "@/utils/join"
import { usePopUpMenu } from "@/utils/usePopUpMenu"

import { ContactUs } from "./ContactUs"
import { FollowUs } from "./FollowUs"

export const ContactUsButton = () => {
  const { t } = useTranslation()
  const ref = useRef<HTMLDivElement>(null)
  const [displayMenu, setDisplayMenu] = usePopUpMenu(ref)

  return (
    <div className="relative flex items-center gap-xs">
      <Button
        variant="primary"
        size="sm"
        onClick={() => setDisplayMenu((prev) => !prev)}
      >
        {/* 
        TODO (SU-75): Refactor button to allow icons 
        <MailIcon height="1" width="1" active={displayMenu} />
        */}
        {t("getInTouch")}
      </Button>

      <div
        className={join(
          displayMenu ? "flex" : "hidden",
          "absolute right-0 bottom-9 z-5 items-center justify-center rounded-md border border-solid border-primary bg-primary shadow-[0_7px_26px_0_rgba(23,24,25,0.5)]",
        )}
      >
        <div className="relative z-1 w-full min-w-56">
          <div className="mx-1 my-4">
            <ContactUs />
            <FollowUs />
            <div className="px-2 pt-4 pb-0">
              <DefaultAdaptiveLogo size={1.25} />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
